import { useState, useEffect } from "react";
import Modal from "react-modal";
import api from "../../services/api.js";
import "./style.css";
import FloatingMenu from "../../componente/menuflutuante";
import Aguarde from "../../../src/componente/aguarde/index.jsx";
import { IMaskInput } from "react-imask";

Modal.setAppElement("#root");

export default function Cobranca() {
  const { DateTime } = require("luxon");

  const [buscaCliente, setBuscaCliente] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [produtosBrinde, setProdutosBrinde] = useState([]);
  const [listaProdutos, setListaProdutos] = useState([]);
  const [buscaBrinde, setBuscaBrinde] = useState("");
  const [moedas, setMoedas] = useState([]);
  const [loading, setLoading] = useState(false);

  const [percComissao, setPercComissao] = useState(30);
  const [pagamentos, setPagamentos] = useState([]);

  // NOVO - REPASSE
  const [repasse, setRepasse] = useState(null);
  const [pagamentosRepasse, setPagamentosRepasse] = useState([]);
  const [modalRepasseOpen, setModalRepasseOpen] = useState(false);

  // ============================
  // ATALHO NOVA VENDA
  // ============================
  // ============================
  // ATALHO NOVA VENDA
  // ============================

  const [modalCadastro, setModalCadastro] = useState(false);

  const [form, setForm] = useState({
    nome: "",
    cpf: "",
    cep: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    uf: "",
    telefone: "",
    whatsapp: ""
  });

  const [erros, setErros] = useState({});

  // Indica que o cadastro foi aberto pela Nova Venda
  const [cadastroPelaNovaVenda, setCadastroPelaNovaVenda] = useState(false);

  const [modalNovaVenda, setModalNovaVenda] = useState(false);
  const [buscaCPFNovaVenda, setBuscaCPFNovaVenda] = useState("");
  const [buscaNomeNovaVenda, setBuscaNomeNovaVenda] = useState("");
  const [clientesNovaVenda, setClientesNovaVenda] = useState([]);
  const [clienteNovaVenda, setClienteNovaVenda] = useState(null);
  const [buscaClienteNovaVendaModal, setBuscaClienteNovaVendaModal] = useState("");

  const [modalProdutosVenda, setModalProdutosVenda] = useState(false);
  const [produtosVenda, setProdutosVenda] = useState([]);
  const [itensVenda, setItensVenda] = useState([]);
  const [selecaoProdutosVenda, setSelecaoProdutosVenda] = useState({});
  const [ordemSelecaoVenda, setOrdemSelecaoVenda] = useState([]);
  const [buscaProdutoVenda, setBuscaProdutoVenda] = useState("");

  const hoje = new Date().toISOString().split("T")[0];

  const [tipoBusca, setTipoBusca] = useState("T"); // T=Todos C=Cobrança R=Repasse
  const [dataInicio, setDataInicio] = useState(hoje);
  const [dataFim, setDataFim] = useState(hoje);

  const isMobile = window.innerWidth <= 768;

  function formatDate(dateStr) {
    return dateStr
      ? DateTime.fromISO(dateStr).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : "";
  }

  // ALTERADO
  async function abrirModal(cliente) {
    if (cliente.cobranca === "S") {
      abrirModalRepasse(cliente);
      return;
    }

    try {
      setClienteSelecionado(cliente);
      setPagamentos([]);
      setProdutosBrinde([]);
      setBuscaBrinde("");
      setLoading(true);

      const response = await api.get("v1/cobranca/produtos", {
        params: { codvenda: cliente.codvenda },
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      const moedasResp = await api.get("v1/cobranca/moeda", {
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      const produtosResp = await api.get("v1/venda/produto", {
        params: {
          codequipe: localStorage.getItem("tempCodEquipe"),
          tipo: localStorage.getItem("tempTipo"),
          codfuncionario: localStorage.getItem("tempCodFuncionario"),
          descricao: ''
        },
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      setMoedas(moedasResp.data);
      setListaProdutos(produtosResp.data);

      setProdutos(
        response.data.map((p) => ({
          ...p,
          devolvido: 0,
        }))
      );
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setModalOpen(true);
      setLoading(false);
    }
  }

  // ============================
  // NOVO MODAL REPASSE
  // ============================

  async function abrirModalRepasse(cliente) {
    try {
      setClienteSelecionado(cliente);
      setLoading(true);

      const moedasResp = await api.get("v1/cobranca/moeda", {
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      const resp = await api.get("v1/cobranca/repasse", {
        params: { codvenda: cliente.codvenda },
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      setMoedas(moedasResp.data);
      setRepasse(resp.data);
      setPagamentosRepasse([]);
    } catch (error) {
      console.error(error);
    } finally {
      setModalRepasseOpen(true);
      setLoading(false);
    }
  }

  function addPagamentoRepasse() {
    setPagamentosRepasse([...pagamentosRepasse, { codmoeda: "", valor: 0 }]);
  }

  function updatePagamentoRepasse(index, field, value) {
    setPagamentosRepasse((prev) =>
      prev.map((p, i) =>
        i === index ? { ...p, [field]: value } : p
      )
    );
  }

  function removerPagamentoRepasse(index) {
    setPagamentosRepasse(pagamentosRepasse.filter((_, i) => i !== index));
  }

  async function excluirPagamento(coddetalhe) {
    if (!window.confirm("Deseja excluir esse pagamento?")) return;

    try {
      setLoading(true);

      await api.delete("v1/cobranca/repasse", {
        params: {
          coddetalhe,
        },
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      abrirModalRepasse(clienteSelecionado);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const totalPagoRepasse = repasse?.listapagamento?.reduce(
    (s, p) => s + Number(p.valor || 0),
    0
  ) || 0;

  const totalFaltando = (repasse?.valorempresa || 0) - totalPagoRepasse;

  async function salvarRepasse() {
    try {
      setLoading(true);

      await api.post("v1/cobranca/repasse", {
        codcontasreceber: repasse.codcontasreceber,
        pagamentos: pagamentosRepasse
      }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      abrirModalRepasse(clienteSelecionado);
      setPagamentosRepasse([]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setModalRepasseOpen(false);
      ListarCobranca();
    }
  }

  // ============================

  function alterarQtd(codvendaitem, tipo) {
    setProdutos((prev) =>
      prev.map((p) => {
        if (p.codvendaitem === codvendaitem) {
          let nova =
            tipo === "+"
              ? p.devolvido + 1
              : p.devolvido - 1;

          if (nova < 0) nova = 0;
          if (nova > p.qtde) nova = p.qtde;

          return {
            ...p,
            devolvido: nova,
          };
        }

        return p;
      })
    );
  }

  function addBrinde(prod) {
    if (produtosBrinde.find(b => b.codproduto === prod.codproduto)) return;

    setProdutosBrinde([
      ...produtosBrinde,
      {
        ...prod,
        qtde: 1
      }
    ]);

    setBuscaBrinde("");
  }

  function alterarQtdBrinde(codproduto, tipo) {
    setProdutosBrinde(prev =>
      prev.map(b => {
        if (b.codproduto !== codproduto) return b;

        let nova = tipo === "+" ? b.qtde + 1 : b.qtde - 1;

        if (nova < 1) nova = 1;
        if (nova > b.estoque) nova = b.estoque; // 🔒 limite pelo estoque

        return { ...b, qtde: nova };
      })
    );
  }

  function removerBrinde(codproduto) {
    setProdutosBrinde(prev =>
      prev.filter(b => b.codproduto !== codproduto)
    );
  }

  function addPagamento() {
    setPagamentos([...pagamentos, { codmoeda: "", valor: 0 }]);
  }

  function updatePagamento(index, field, value) {
    setPagamentos((prev) =>
      prev.map((p, i) =>
        i === index ? { ...p, [field]: value } : p
      )
    );
  }

  function removerPagamento(index) {
    setPagamentos(pagamentos.filter((_, i) => i !== index));
  }

  const totalVenda = produtos.reduce(
    (s, p) =>
      s +
      (p.qtde - (p.devolvido || 0)) * p.vlunit,
    0
  );

  const totalCliente = (totalVenda * percComissao) / 100;
  const totalEmpresa = totalVenda - totalCliente;

  const totalPago = pagamentos.reduce(
    (s, p) => s + Number(p.valor || 0),
    0
  );

  const totalAberto = totalEmpresa - totalPago;

  const totalBrindes = produtosBrinde.reduce(
    (s, b) => s + (b.qtde * b.preco),
    0
  );

  const totalDevolvido = produtos.reduce(
    (s, p) => s + ((p.devolvido || 0) * Number(p.vlunit || 0)),
    0
  );

  const status =
    totalPago === 0
      ? "A"
      : totalAberto > 0
        ? "P"
        : "Q";

  async function salvarCobranca() {
    try {
      setLoading(true);
      const payload = {
        codvenda: clienteSelecionado.codvenda,
        tipo: localStorage.getItem("tempTipo"),
        codusuario: localStorage.getItem("tempCodUsuario"),
        codcliente: clienteSelecionado.codcliente,
        codfuncionario: localStorage.getItem("tempCodFuncionario"),
        codequipe: localStorage.getItem("tempCodEquipe"),
        status,
        totalbrinde: totalBrindes,
        totalvendido: totalVenda,
        totalempresa: totalEmpresa,
        totalcliente: totalCliente,
        perccomissaocliente: percComissao,
        totalpago: totalPago,
        totalaberto: totalAberto,
        pagamentos,
        produtos,
        produtosBrinde
      };

      await api.post("v1/cobranca/cobranca", payload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("tempToken")}` },
      });

      ListarCobranca();
      alert("Cobrança salva com sucesso!");
      setModalOpen(false);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  }

  const clientesFiltrados = clientes.filter((c) => {
    const termo = buscaCliente.toLowerCase();

    return (
      c.nome?.toLowerCase().includes(termo) ||
      c.cpf?.toLowerCase().includes(termo) ||
      c.codcliente?.toString().includes(termo) ||
      c.telefone?.toLowerCase().includes(termo)
    );
  });

  const clientesNovaVendaFiltrados = clientesNovaVenda.filter((cliente) => {
    const termo = buscaClienteNovaVendaModal.toLowerCase().trim();

    if (!termo) return true;

    return (
      cliente.nome?.toLowerCase().includes(termo) ||
      cliente.cpf?.toLowerCase().includes(termo) ||
      cliente.codcliente?.toString().includes(termo) ||
      cliente.telefone?.toLowerCase().includes(termo)
    );
  });

  async function abrirNovaVenda() {
    setBuscaCPFNovaVenda("");
    setBuscaNomeNovaVenda("");
    setBuscaClienteNovaVendaModal("");

    setClientesNovaVenda([]);
    setClienteNovaVenda(null);
    setItensVenda([]);
    setSelecaoProdutosVenda({});
    setOrdemSelecaoVenda([]);
    setBuscaProdutoVenda("");

    setModalNovaVenda(true);
  }

  async function pesquisarClienteNovaVenda() {
    const nome = buscaNomeNovaVenda.trim();

    if (!nome) {
      alert("Digite o nome ou CPF da cliente.");
      return;
    }

    try {
      setLoading(true);

      const response = await api.get("/v1/venda/consultacpf", {
        params: {
          cpf: buscaCPFNovaVenda,
          cliente: nome,
          codequipe: localStorage.getItem("tempCodEquipe")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`
        }
      });

      if (
        response.data.encontrado === "sim" &&
        response.data.dados?.length > 0
      ) {
        setClientesNovaVenda(response.data.dados);
      } else {
        alert("Nenhuma cliente localizada.");
        setClientesNovaVenda([]);
      }

    } catch (error) {
      console.error("Erro ao pesquisar cliente:", error);
      alert("Erro ao pesquisar cliente.");
    } finally {
      setLoading(false);
    }
  }

  async function selecionarClienteNovaVenda(cliente) {
    try {
      setLoading(true);

      setClienteNovaVenda(cliente);
      setItensVenda([]);
      setSelecaoProdutosVenda({});
      setOrdemSelecaoVenda([]);
      setBuscaProdutoVenda("");

      const response = await api.get("v1/venda/produto", {
        params: {
          codfuncionario: localStorage.getItem("tempCodFuncionario"),
          descricao: "",
          tipo: localStorage.getItem("tempTipo"),
          codequipe: localStorage.getItem("tempCodEquipe")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`
        }
      });

      setProdutosVenda(response.data);

      setModalNovaVenda(false);
      setModalProdutosVenda(true);

    } catch (error) {
      console.error("Erro ao carregar produtos:", error);
      alert("Erro ao carregar produtos.");
    } finally {
      setLoading(false);
    }
  }

  function selecionarProdutoVenda(produto, marcado) {
    setSelecaoProdutosVenda(prev => {
      const copia = { ...prev };

      if (marcado) {
        copia[produto.codproduto] = {
          produto,
          quantidade: 1
        };
      } else {
        delete copia[produto.codproduto];
      }

      return copia;
    });

    setOrdemSelecaoVenda(prev => {
      if (marcado) {
        // Adiciona o produto no final da ordem de seleção
        return [...prev, produto.codproduto];
      } else {
        // Remove o produto da ordem quando desmarcado
        return prev.filter(cod => cod !== produto.codproduto);
      }
    });
  }

  function alterarQtdSelecaoVenda(codproduto, quantidade) {
    setSelecaoProdutosVenda(prev => ({
      ...prev,
      [codproduto]: {
        ...prev[codproduto],
        quantidade
      }
    }));
  }

  function calcularTotalItemVenda(item) {
    const desconto = item.usoProprio
      ? (item.percentual || 0) / 100
      : 0;

    return item.quantidade * item.preco * (1 - desconto);
  }

  function adicionarProdutosVenda() {
    let lista = [...itensVenda];

    ordemSelecaoVenda.forEach(codproduto => {

      const item = selecaoProdutosVenda[codproduto];

      if (!item) return;

      const existente = lista.find(
        i => i.codproduto === item.produto.codproduto
      );

      if (existente) {

        existente.quantidade += item.quantidade;
        existente.total = calcularTotalItemVenda(existente);

      } else {

        const novo = {
          ...item.produto,
          quantidade: item.quantidade,
          usoProprio: false,
          percentual: 0,
          codvendaitem: 0
        };

        novo.total = calcularTotalItemVenda(novo);

        lista.push(novo);
      }
    });

    setItensVenda(lista);

    setSelecaoProdutosVenda({});
    setOrdemSelecaoVenda([]);

    setBuscaProdutoVenda("");
    setModalProdutosVenda(false);
  }

  function removerProdutoVenda(codproduto) {
    setItensVenda(prev =>
      prev.filter(i => i.codproduto !== codproduto)
    );
  }

  function alterarQtdVenda(codproduto, qtd) {
    setItensVenda(prev =>
      prev.map(i => {
        if (i.codproduto !== codproduto) return i;

        const atualizado = {
          ...i,
          quantidade: qtd
        };

        atualizado.total = calcularTotalItemVenda(atualizado);

        return atualizado;
      })
    );
  }

  function alterarPrecoVenda(codproduto, preco) {
    setItensVenda(prev =>
      prev.map(i => {
        if (i.codproduto !== codproduto) return i;

        const atualizado = {
          ...i,
          preco
        };

        atualizado.total = calcularTotalItemVenda(atualizado);

        return atualizado;
      })
    );
  }

  const totalVendaAtalho = itensVenda.reduce(
    (s, i) => s + i.total,
    0
  );

  async function salvarNovaVenda() {
    if (!clienteNovaVenda) {
      alert("Selecione uma cliente.");
      return;
    }

    if (itensVenda.length === 0) {
      alert("Adicione pelo menos um produto.");
      return;
    }

    try {
      setLoading(true);

      await api.post(
        "v1/venda/venda",
        {
          codvenda: 0,
          itens: itensVenda,
          codusuario: localStorage.getItem("tempCodUsuario"),
          codvendedor: localStorage.getItem("tempCodFuncionario"),
          codcliente: clienteNovaVenda.codcliente,
          total: totalVendaAtalho,
          tipo: localStorage.getItem("tempTipo"),
          codequipe: localStorage.getItem("tempCodEquipe")
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`
          }
        }
      );

      alert("Venda salva com sucesso!");

      setModalProdutosVenda(false);
      setModalNovaVenda(false);
      setClienteNovaVenda(null);
      setItensVenda([]);
      setSelecaoProdutosVenda({});
      setOrdemSelecaoVenda([]);

      // Atualiza a cobrança
      ListarCobranca();

    } catch (error) {
      console.error("Erro ao salvar venda:", error);
      alert("Erro ao salvar venda.");
    } finally {
      setLoading(false);
    }
  }

  async function ListarCobranca() {
    try {
      setLoading(true);

      const response = await api.get("v1/cobranca/clientes", {
        params: {
          codequipe: localStorage.getItem("tempCodEquipe"),
          tipo: tipoBusca,
          datainicio: dataInicio,
          datafim: dataFim
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setClientes(response.data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    ListarCobranca();
  }, [tipoBusca, dataInicio, dataFim]);

  function abrirCadastroClienteNovaVenda() {

    setCadastroPelaNovaVenda(true);

    // Abre o cadastro já aproveitando
    // o nome e CPF que foram digitados na busca.
    setForm(prev => ({
      ...prev,
      nome: buscaNomeNovaVenda.trim(),
      cpf: buscaCPFNovaVenda
    }));

    setErros({});

    // Fecha o modal de pesquisa
    setModalNovaVenda(false);

    // Abre o modal de cadastro
    setModalCadastro(true);
  }

  function validarFormulario() {
    let novosErros = {};

    if (!form.nome.trim()) {
      novosErros.nome = "Nome é obrigatório";
    }

    if (!form.endereco.trim()) {
      novosErros.endereco = "Endereço é obrigatório";
    }

    if (!form.numero.trim()) {
      novosErros.numero = "Número é obrigatório";
    }

    if (!form.bairro.trim()) {
      novosErros.bairro = "Bairro é obrigatório";
    }

    if (!form.cidade.trim()) {
      novosErros.cidade = "Cidade é obrigatório";
    }

    if (!form.uf.trim()) {
      novosErros.uf = "UF é obrigatório";
    }

    if (!form.telefone || form.telefone.length < 15) {
      novosErros.telefone = "Telefone é obrigatório";
    }

    setErros(novosErros);

    return Object.keys(novosErros).length === 0;
  }

  async function buscarCEP() {
    if (form.cep.replace(/\D/g, "").length !== 8) return;

    const { data } = await api.get(
      `https://viacep.com.br/ws/${form.cep.replace(/\D/g, "")}/json/`
    );

    setForm({
      ...form,
      endereco: data.logradouro || "",
      bairro: data.bairro || "",
      cidade: data.localidade || "",
      uf: data.uf || ""
    });
  }

  async function salvarCliente() {

    try {

      setLoading(true);

      const response = await api.post(
        "v1/venda/cliente",
        {
          form,

          codusuario:
            localStorage.getItem("tempCodUsuario"),

          codequipe:
            localStorage.getItem("tempCodEquipe"),

          codvendedor:
            localStorage.getItem("tempCodFuncionario")
        },
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      );

      // Monta o cliente recém-cadastrado
      const novoCliente = {
        ...form,
        codcliente: response.data.codcliente
      };

      // =====================================================
      // CADASTRO FEITO PELO MODAL DE NOVA VENDA
      // =====================================================

      if (cadastroPelaNovaVenda) {

        // Define o novo cliente como cliente da venda
        setClienteNovaVenda(novoCliente);

        // Limpa produtos anteriores
        setItensVenda([]);

        setSelecaoProdutosVenda({});
        setOrdemSelecaoVenda([]);

        setBuscaProdutoVenda("");

        // Busca os produtos disponíveis
        const produtosResp = await api.get(
          "v1/venda/produto",
          {
            params: {
              codfuncionario:
                localStorage.getItem(
                  "tempCodFuncionario"
                ),

              descricao: "",

              tipo:
                localStorage.getItem("tempTipo"),

              codequipe:
                localStorage.getItem(
                  "tempCodEquipe"
                )
            },

            headers: {
              Authorization:
                `Bearer ${localStorage.getItem("tempToken")}`
            }
          }
        );

        setProdutosVenda(produtosResp.data);

        // Fecha o cadastro
        setModalCadastro(false);

        // Abre diretamente a tela de produtos da venda
        setModalProdutosVenda(true);

        // Reseta a origem
        setCadastroPelaNovaVenda(false);

      } else {

        // =====================================================
        // OUTRO FLUXO DE CADASTRO
        // =====================================================

        setModalCadastro(false);

      }

    } catch (error) {

      console.error(
        "Erro ao salvar cliente:",
        error
      );

      alert("Erro ao salvar cliente");

    } finally {

      setLoading(false);
    }
  }

  return (
    <div className="container-fluid p-3">
      <FloatingMenu />
      <h4 className="mb-4">Cobrança</h4>

      <input
        type="text"
        className="form-control mb-3"
        placeholder="Buscar cliente (nome, CPF, código, telefone)"
        value={buscaCliente}
        onChange={(e) => setBuscaCliente(e.target.value)}
      />

      <div className="filtros-cobranca">

        <div className="grupo-radio">

          <label>
            <input
              type="radio"
              name="tipoBusca"
              checked={tipoBusca === "T"}
              onChange={() => setTipoBusca("T")}
            />
            Todos
          </label>

          <label>
            <input
              type="radio"
              name="tipoBusca"
              checked={tipoBusca === "C"}
              onChange={() => setTipoBusca("C")}
            />
            Cobrança
          </label>

          <label>
            <input
              type="radio"
              name="tipoBusca"
              checked={tipoBusca === "R"}
              onChange={() => setTipoBusca("R")}
            />
            Repasse
          </label>

        </div>

        <div className="grupo-datas">

          <div>
            <small>Início</small>
            <input
              type="date"
              className="form-control"
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
            />
          </div>

          <div>
            <small>Fim</small>
            <input
              type="date"
              className="form-control"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
            />
          </div>

        </div>

      </div>

      <div className="atalho-venda-container">
        <button
          className="btn btn-success atalho-venda"
          onClick={abrirNovaVenda}
        >
          🛒 Nova Venda
        </button>
      </div>

      <div className="d-none d-md-block">
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Data</th>
                <th>Código</th>
                <th>Nome</th>
                <th>CPF</th>
                <th>Endereço</th>
                <th>Telefone</th>
                <th>WhatsApp</th>
                <th>Vl. Venda</th>
                <th>Vl. Repasse</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {clientesFiltrados.map((c) => (
                <tr key={c.codvenda}>
                  <td>{formatDate(c.dtvenda)}</td>
                  <td>{c.codcliente}</td>
                  <td>{c.nome}</td>
                  <td>{c.cpf}</td>
                  <td>
                    {c.endereco}, {c.numero} - {c.bairro} - {c.cidade} - {c.uf}
                  </td>
                  <td>{c.telefone}</td>
                  <td>{c.whatsapp}</td>
                  <td>{Number(c.valorvenda).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}</td>
                  <td>{Number(c.valorrepasse).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}</td>
                  <td>
                    <button
                      className="btn btn-primary btn-sm"
                      onClick={() => abrirModal(c)}
                    >
                      Prestação
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="d-block d-md-none marginb">
        {clientesFiltrados.map((c) => (
          <div key={c.codvenda} className="card mb-3 shadow-sm">
            <div className="card-body">
              <h6 className="fw-bold mb-1">{c.nome}</h6>

              <div className="small text-muted mb-2">
                {formatDate(c.dtvenda)} • Código {c.codcliente}
              </div>

              <p className="mb-1">
                <strong>CPF:</strong> {c.cpf}
              </p>

              <p className="mb-1">
                <strong>Endereço:</strong><br />
                {c.endereco}, {c.numero}<br />
                {c.bairro} – {c.cidade}/{c.uf}
              </p>

              <p className="mb-1">
                <strong>Telefone:</strong> {c.telefone}
              </p>

              <p className="mb-2">
                <strong>WhatsApp:</strong> {c.whatsapp}
              </p>

              <div className="row g-2 mb-3">
                <div className="col-6">
                  <div className="border rounded p-2 text-center bg-light">
                    <small className="text-muted d-block">Venda</small>
                    <strong className="text-success">
                      {Number(c.valorvenda).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </strong>
                  </div>
                </div>

                <div className="col-6">
                  <div className="border rounded p-2 text-center bg-light">
                    <small className="text-muted d-block">Repasse</small>
                    <strong className="text-primary">
                      {Number(c.valorrepasse).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </strong>
                  </div>
                </div>
              </div>

              <button
                className="btn btn-primary w-100"
                onClick={() => abrirModal(c)}
              >
                Prestação de Contas
              </button>
            </div>
          </div>
        ))}
      </div>

      {loading && <Aguarde />}

      {/* MODAL CADASTRO */}
      <Modal
        isOpen={modalCadastro}
        onRequestClose={() => setModalCadastro(false)}
        overlayClassName="modal-overlay"
        className="modal-box"
      >
        <div className="modal-header">
          <h5>Cadastro de Cliente</h5>
          <button
            className="btn-close"
            onClick={() => setModalCadastro(false)}
          />
        </div>

        <div className="modal-body">
          <div className="row g-2">

            <div className="col-12">
              <input
                className={`form-control ${erros.nome ? "is-invalid" : ""}`}
                placeholder="Nome"
                value={form.nome}
                onChange={(e) => {
                  setForm({ ...form, nome: e.target.value });
                  setErros({ ...erros, nome: null });
                }}
              />

              {erros.nome && (
                <div className="invalid-feedback">
                  {erros.nome}
                </div>
              )}
            </div>

            <div className="col-6">
              <IMaskInput
                mask="000.000.000-00"
                className="form-control"
                placeholder="CPF"
                value={form.cpf}
                onAccept={(v) =>
                  setForm({ ...form, cpf: v })
                }
              />
            </div>

            <div className="col-6">
              <IMaskInput
                mask="00000-000"
                className="form-control"
                placeholder="CEP"
                value={form.cep}
                onAccept={(v) =>
                  setForm({ ...form, cep: v })
                }
                onBlur={buscarCEP}
              />
            </div>

            <div className="col-8">
              <input
                className={`form-control ${erros.endereco ? "is-invalid" : ""}`}
                placeholder="Endereço"
                value={form.endereco}
                onChange={(e) => {
                  setForm({ ...form, endereco: e.target.value });
                  setErros({ ...erros, endereco: null });
                }}
              />

              {erros.endereco && (
                <div className="invalid-feedback">
                  {erros.endereco}
                </div>
              )}
            </div>

            <div className="col-4">
              <input
                className={`form-control ${erros.numero ? "is-invalid" : ""}`}
                placeholder="Número"
                value={form.numero}
                onChange={(e) => {
                  setForm({ ...form, numero: e.target.value });
                  setErros({ ...erros, numero: null });
                }}
              />

              {erros.numero && (
                <div className="invalid-feedback">
                  {erros.numero}
                </div>
              )}
            </div>

            <div className="col-12">
              <input
                className="form-control"
                placeholder="Complemento"
                value={form.complemento}
                onChange={(e) =>
                  setForm({ ...form, complemento: e.target.value })
                }
              />
            </div>

            <div className="col-6">
              <input
                className={`form-control ${erros.bairro ? "is-invalid" : ""}`}
                placeholder="Bairro"
                value={form.bairro}
                onChange={(e) => {
                  setForm({ ...form, bairro: e.target.value });
                  setErros({ ...erros, bairro: null });
                }}
              />

              {erros.bairro && (
                <div className="invalid-feedback">
                  {erros.bairro}
                </div>
              )}
            </div>

            <div className="col-4">
              <input
                className={`form-control ${erros.cidade ? "is-invalid" : ""}`}
                placeholder="Cidade"
                value={form.cidade}
                onChange={(e) => {
                  setForm({ ...form, cidade: e.target.value });
                  setErros({ ...erros, cidade: null });
                }}
              />

              {erros.cidade && (
                <div className="invalid-feedback">
                  {erros.cidade}
                </div>
              )}
            </div>

            <div className="col-2">
              <input
                className={`form-control ${erros.uf ? "is-invalid" : ""}`}
                placeholder="UF"
                value={form.uf}
                onChange={(e) => {
                  setForm({ ...form, uf: e.target.value });
                  setErros({ ...erros, uf: null });
                }}
              />

              {erros.uf && (
                <div className="invalid-feedback">
                  {erros.uf}
                </div>
              )}
            </div>

            <div className="col-6">
              <IMaskInput
                mask="(00) 00000-0000"
                className={`form-control ${erros.telefone ? "is-invalid" : ""}`}
                placeholder="Telefone"
                value={form.telefone}
                onAccept={(value) => {
                  setForm({ ...form, telefone: value });
                  setErros({ ...erros, telefone: null });
                }}
              />

              {erros.telefone && (
                <div className="invalid-feedback">
                  {erros.telefone}
                </div>
              )}
            </div>

            <div className="col-6">
              <IMaskInput
                mask="(00) 00000-0000"
                className="form-control"
                placeholder="WhatsApp"
                value={form.whatsapp}
                onAccept={(v) =>
                  setForm({ ...form, whatsapp: v })
                }
              />
            </div>

          </div>
        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setModalCadastro(false)}
          >
            Cancelar
          </button>

          <button
            className="btn btn-success"
            onClick={() => {
              if (validarFormulario()) {
                salvarCliente();
              }
            }}
          >
            Salvar
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={modalNovaVenda}
        onRequestClose={() => setModalNovaVenda(false)}
        className="modal-box"
        overlayClassName="modal-overlay"
      >
        <div className="modal-header">
          <h5>Nova Venda</h5>

          <button
            className="btn-close"
            onClick={() => {
              setModalNovaVenda(false);
              setBuscaClienteNovaVendaModal("");
            }}
          />
        </div>

        <div className="modal-body">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Nome"
              value={buscaNomeNovaVenda}
              onChange={(e) => setBuscaNomeNovaVenda(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  pesquisarClienteNovaVenda();
                }
              }}
            />

            <button
              className="btn btn-primary"
              onClick={pesquisarClienteNovaVenda}
            >
              Pesquisar
            </button>
          </div>

          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="CPF"
              value={buscaCPFNovaVenda}
              onChange={(e) => setBuscaCPFNovaVenda(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  pesquisarClienteNovaVenda();
                }
              }}
            />

            <button
              className="btn btn-primary"
              onClick={pesquisarClienteNovaVenda}
            >
              Pesquisar
            </button>
          </div>

          {/* LISTA DE CLIENTES ENCONTRADOS */}
          {clientesNovaVenda.length > 0 && (
            <>
              {/* BUSCA LOCAL */}
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="🔎 Filtrar por nome, CPF, código ou telefone..."
                  value={buscaClienteNovaVendaModal}
                  onChange={(e) =>
                    setBuscaClienteNovaVendaModal(e.target.value)
                  }
                  autoFocus
                />
              </div>

              <div className="lista-clientes-venda">
                {clientesNovaVendaFiltrados.length === 0 ? (
                  <div className="text-center text-muted py-3">
                    Nenhum cliente encontrado.
                  </div>
                ) : (
                  clientesNovaVendaFiltrados.map((cliente) => (
                    <div
                      key={cliente.codcliente}
                      className="cliente-venda-card"
                      onClick={() => selecionarClienteNovaVenda(cliente)}
                    >
                      {/* NOME E VALOR EM ABERTO */}
                      <div className="d-flex justify-content-between align-items-center gap-2">
                        <div className="cliente-nome">
                          {cliente.nome}
                        </div>

                        <strong className="text-danger text-nowrap">
                          Em aberto:{" "}
                          {Number(cliente.valor || 0).toLocaleString(
                            "pt-BR",
                            {
                              style: "currency",
                              currency: "BRL",
                            }
                          )}
                        </strong>
                      </div>

                      {/* CPF E EQUIPE */}
                      <div className="cliente-info">
                        <span>
                          <strong>CPF:</strong>{" "}
                          {cliente.cpf || "Não informado"}
                        </span>

                        <span>
                          <strong>Equipe:</strong>{" "}
                          {cliente.equipe || "Não informada"}
                        </span>
                      </div>

                      {/* ENDEREÇO */}
                      <div className="cliente-endereco">
                        <strong>Endereço:</strong>{" "}
                        {[
                          cliente.endereco,
                          cliente.numero,
                          cliente.bairro,
                          cliente.cidade,
                          cliente.uf,
                        ]
                          .filter((item) => item != null && String(item).trim() !== "")
                          .join(", ") || "Não informado"}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </>
          )}
        </div>

        <div className="modal-footer d-flex gap-2">
          <button
            className="btn btn-secondary"
            onClick={() => {
              setModalNovaVenda(false);
              setBuscaClienteNovaVendaModal("");
            }}
          >
            Cancelar
          </button>

          <button
            className="btn btn-primary"
            onClick={abrirCadastroClienteNovaVenda}
          >
            + Novo Cliente
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={modalProdutosVenda}
        onRequestClose={() => setModalProdutosVenda(false)}
        className="modal-box modal-lg"
        overlayClassName="modal-overlay"
      >
        <div className="modal-header">
          <h5>
            Venda para: {clienteNovaVenda?.nome}
          </h5>

          <button
            className="btn-close"
            onClick={() => setModalProdutosVenda(false)}
          />
        </div>

        <div className="modal-body">

          <input
            className="form-control mb-3"
            placeholder="Buscar produto"
            value={buscaProdutoVenda}
            onChange={e => setBuscaProdutoVenda(e.target.value)}
          />

          {produtosVenda
            .filter(p =>
              p.descricao
                .toLowerCase()
                .includes(buscaProdutoVenda.toLowerCase())
            )
            .map(produto => {

              const marcado =
                selecaoProdutosVenda[produto.codproduto];

              return (
                <div
                  key={produto.codproduto}
                  className="produto-card"
                >

                  <div className="produto-info">

                    <input
                      type="checkbox"
                      checked={!!marcado}
                      onChange={e =>
                        selecionarProdutoVenda(
                          produto,
                          e.target.checked
                        )
                      }
                    />

                    <div>
                      <strong>
                        {produto.descricao}
                      </strong>

                      <div className="produto-detalhes">
                        R$ {produto.preco.toFixed(2)}
                        {" • "}
                        Estoque: {produto.estoque}
                      </div>
                    </div>

                  </div>

                  <input
                    type="number"
                    className="form-control"
                    min={1}
                    max={produto.estoque}
                    disabled={!marcado}
                    value={
                      marcado
                        ? marcado.quantidade
                        : 1
                    }
                    onChange={e =>
                      alterarQtdSelecaoVenda(
                        produto.codproduto,
                        Number(e.target.value)
                      )
                    }
                  />

                </div>
              );
            })}

        </div>

        <div className="modal-footer">

          <button
            className="btn btn-secondary"
            onClick={() => setModalProdutosVenda(false)}
          >
            Cancelar
          </button>

          <button
            className="btn btn-success"
            onClick={adicionarProdutosVenda}
          >
            Adicionar
          </button>

        </div>
      </Modal>

      <Modal
        isOpen={itensVenda.length > 0 && !modalProdutosVenda}
        onRequestClose={() => { }}
        className="modal-box modal-lg"
        overlayClassName="modal-overlay"
      >
        <div className="modal-header">
          <h5>
            Venda para: {clienteNovaVenda?.nome}
          </h5>
        </div>

        <div className="modal-body">

          {itensVenda.map(item => (
            <div
              key={item.codproduto}
              className="border rounded p-2 mb-2"
            >

              <div className="d-flex justify-content-between">
                <strong>{item.descricao}</strong>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() =>
                    removerProdutoVenda(item.codproduto)
                  }
                >
                  🗑
                </button>
              </div>

              <div className="row mt-2">

                <div className="col-md-4">
                  <label>Quantidade</label>

                  <input
                    type="number"
                    min="1"
                    className="form-control"
                    value={item.quantidade}
                    onChange={e =>
                      alterarQtdVenda(
                        item.codproduto,
                        Number(e.target.value)
                      )
                    }
                  />
                </div>

                <div className="col-md-4">
                  <label>Preço</label>

                  <input
                    type="number"
                    className="form-control"
                    value={item.preco}
                    onChange={e =>
                      alterarPrecoVenda(
                        item.codproduto,
                        Number(e.target.value)
                      )
                    }
                  />
                </div>

                <div className="col-md-4">
                  <label>Total</label>

                  <div className="form-control bg-light">
                    R$ {item.total.toFixed(2)}
                  </div>
                </div>

              </div>

            </div>
          ))}

          <hr />

          <div className="alert alert-info">
            <strong>
              Total da venda:
            </strong>

            {" "}
            R$ {totalVendaAtalho.toFixed(2)}
          </div>

        </div>

        <div className="modal-footer">

          <button
            className="btn btn-primary"
            onClick={() => setModalProdutosVenda(true)}
          >
            + Adicionar Produtos
          </button>

          <button
            className="btn btn-success"
            onClick={salvarNovaVenda}
          >
            Finalizar Venda
          </button>

        </div>
      </Modal>

      {/* ========================= */}
      {/* MODAL REPASSE NOVO */}
      {/* ========================= */}
      <Modal
        isOpen={modalRepasseOpen}
        className="modal-box"
        overlayClassName="modal-overlay"
      >
        <div className="modal-header">
          <h5>Pagamentos - {clienteSelecionado?.nome}</h5>
          <button className="btn-close" onClick={() => setModalRepasseOpen(false)} />
        </div>

        <div className="modal-body">

          <h6>Pagamentos realizados</h6>

          {repasse?.listapagamento?.map(p => (
            <div key={p.coddetalhe} className="border p-2 mb-2 d-flex justify-content-between">
              <div>
                <div><strong>{p.moeda}</strong></div>
                <small>{formatDate(p.dtlancamento)}</small>
              </div>

              <div className="text-end">
                <div>R$ {Number(p.valor).toFixed(2)}</div>
                <button
                  className="btn btn-sm btn-danger mt-1"
                  onClick={() => excluirPagamento(p.coddetalhe)}
                >
                  Excluir
                </button>
              </div>
            </div>
          ))}

          <hr />

          <h6>Novo pagamento</h6>

          {pagamentosRepasse.map((p, i) => (
            <div key={i} className="d-flex gap-2 mb-2">
              <select
                className="form-select"
                value={p.codmoeda}
                onChange={(e) =>
                  updatePagamentoRepasse(i, "codmoeda", e.target.value)
                }
              >
                <option value="">Forma</option>
                {moedas.map((m) => (
                  <option key={m.codmoeda} value={m.codmoeda}>
                    {m.moeda}
                  </option>
                ))}
              </select>

              <input
                type="number"
                className="form-control"
                placeholder="Valor"
                value={p.valor}
                onChange={(e) =>
                  updatePagamentoRepasse(i, "valor", e.target.value)
                }
              />

              <button
                className="btn btn-danger"
                onClick={() => removerPagamentoRepasse(i)}
              >
                ✕
              </button>
            </div>
          ))}

          <button className="btn btn-outline-primary w-100" onClick={addPagamentoRepasse}>
            + Adicionar pagamento
          </button>

          <hr />

          <p>Total empresa: R$ {repasse?.valorempresa?.toFixed(2)}</p>
          <p>Total pago: R$ {totalPagoRepasse.toFixed(2)}</p>
          <p className="fw-bold">Faltando: R$ {totalFaltando.toFixed(2)}</p>

        </div>

        <div className="modal-footer">
          <button className="btn btn-success w-100" onClick={salvarRepasse}>
            Salvar Pagamento
          </button>
        </div>
      </Modal>

      {/* MODAL */}
      <Modal
        isOpen={modalOpen}
        className="modal-box"
        overlayClassName="modal-overlay"
      >
        <div className="modal-header">
          <h5>{clienteSelecionado?.nome}</h5>
          <button className="btn-close" onClick={() => setModalOpen(false)} />
        </div>

        <div className="modal-body">
          {/* PRODUTOS */}
          <h6>Produtos Devolvidos</h6>
          {produtos.map(p => (
            <div
              key={p.codvendaitem}
              className={`mb-3 ${isMobile
                ? "text-center"
                : "d-flex justify-content-between align-items-center"
                }`}
            >
              <div>
                <strong className="d-block">{p.descricao}</strong>

                <small className="text-muted d-block">
                  Vendido: {p.qtde} × R$ {Number(p.vlunit).toFixed(2)} = R$ {Number(p.total).toFixed(2)}
                </small>

                <small className="text-danger d-block fw-bold">
                  Devolvido: {p.devolvido} × R$ {Number(p.vlunit).toFixed(2)} = R$ {(p.devolvido * p.vlunit).toFixed(2)}
                </small>
              </div>

              <div className={isMobile ? "mt-2" : ""}>
                <button
                  className="btn btn-danger"
                  onClick={() => alterarQtd(p.codvendaitem, "-")}
                >
                  -
                </button>

                <span className="mx-2 fw-bold">
                  {p.devolvido}
                </span>

                <button
                  className="btn btn-success"
                  onClick={() => alterarQtd(p.codvendaitem, "+")}
                >
                  +
                </button>
              </div>
            </div>
          ))}

          <hr />

          <h6>Brindes</h6>

          <input
            className="form-control mb-2"
            placeholder="Buscar produto para brinde"
            value={buscaBrinde}
            onChange={(e) => setBuscaBrinde(e.target.value)}
          />

          {buscaBrinde && (
            <div className="list-group mb-3">
              {listaProdutos
                .filter(p =>
                  p.descricao.toLowerCase().includes(buscaBrinde.toLowerCase())
                )
                .slice(0, 6)
                .map(p => (
                  <button
                    key={p.codproduto}
                    className="list-group-item list-group-item-action"
                    onClick={() => addBrinde(p)}
                  >
                    {p.descricao}
                  </button>
                ))}
            </div>
          )}

          {produtosBrinde.map(b => (
            <div
              key={b.codproduto}
              className={`border rounded p-2 mb-2 ${isMobile ? "text-center" : "d-flex justify-content-between"}`}
            >
              <strong>{b.descricao}</strong>

              <div className={isMobile ? "mt-2" : ""}>
                <button className="btn btn-danger" onClick={() => alterarQtdBrinde(b.codproduto, "-")}>-</button>
                <span className="mx-2">{b.qtde}</span>
                <button className="btn btn-success" onClick={() => alterarQtdBrinde(b.codproduto, "+")}>+</button>
                <button className="btn btn-outline-danger ms-2" onClick={() => removerBrinde(b.codproduto)}>
                  Remover
                </button>
              </div>
            </div>
          ))}

          <hr />

          {/* COMISSÃO */}
          <input
            type="number"
            className="form-control mb-2"
            placeholder="% Comissão Cliente"
            value={percComissao}
            onChange={(e) => setPercComissao(e.target.value)}
          />

          {/* PAGAMENTOS */}
          <h6>Pagamentos</h6>
          {pagamentos.map((p, i) => (
            <div key={i} className="d-flex gap-2 mb-2">
              <select
                className="form-select"
                value={p.codmoeda}
                onChange={(e) =>
                  updatePagamento(i, "codmoeda", e.target.value)
                }
              >
                <option value="">Forma</option>
                {moedas.map((m) => (
                  <option key={m.codmoeda} value={m.codmoeda}>
                    {m.moeda}
                  </option>
                ))}
              </select>

              <input
                type="number"
                className="form-control"
                placeholder="Valor"
                value={p.valor}
                onChange={(e) =>
                  updatePagamento(i, "valor", e.target.value)
                }
              />

              <button
                className="btn btn-danger"
                onClick={() => removerPagamento(i)}
              >
                ✕
              </button>
            </div>
          ))}

          <button className="btn btn-outline-primary w-100" onClick={addPagamento}>
            + Adicionar pagamento
          </button>

          <hr />

          <p>Total vendido: R$ {totalVenda.toFixed(2)}</p>
          <p>Total cliente: R$ {totalCliente.toFixed(2)}</p>
          <p>Total pago: R$ {totalPago.toFixed(2)}</p>
          <p>Total brindes: R$ {totalBrindes.toFixed(2)}</p>

          <p className="text-danger fw-bold">
            Total devolvido: R$ {totalDevolvido.toFixed(2)}
          </p>

          <p className="fw-bold">
            Em aberto: R$ {totalAberto.toFixed(2)}
          </p>

          <p>
            Status: <strong>{status}</strong>
          </p>
        </div>

        <div className="modal-footer">
          <button className="btn btn-success w-100" onClick={salvarCobranca}>
            Salvar Prestação
          </button>
        </div>
      </Modal>
    </div>
  );
}
